import { render } from "./NewsroomPagination.vue?vue&type=template&id=1720f5a2"
import script from "./NewsroomPagination.vue?vue&type=script&lang=js"
export * from "./NewsroomPagination.vue?vue&type=script&lang=js"

import exportComponent from "/Users/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__